import React, { useEffect, useState } from "react";
import {
  Button,
  Container,
  Typography,
  Box,
  Grid,
  Menu,
  MenuItem,
  Card,
  CardContent,
  FormControl,
  IconButton,
  InputLabel,
  ListItemText,
  Select,
  Tooltip,
  CircularProgress,
  Autocomplete,
  TextField,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { AddGravitySettingDialog } from "../../../compenents/Setting/Payment/AddGravitySettingDialog";
import {
  useGetGravitySettingsQuery,
  useAddGravitySettingMutation,
  useAddPayPalSettingMutation,
  useDeleteGravityGatewaySettingMutation,
  useGetPayPalSettingsQuery,
  useDeletePayPalSettingMutation,
} from "../../../redux/reducer/features/Gravity/GravitySettingSlice";
import {
  GravitySetting as GravitySettingModel,
  PayPalSetting,
} from "../../../models/features/Gravity/Gravity";
import PageLoader from "../../../compenents/app/PageLoader";
import { AddPayPalSettingDialog } from "../../../compenents/Setting/Payment/AddPayPalSettingDialog";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { PayPalSettingsList } from "../../../compenents/Setting/Payment/PayPalSettingsList";
import { GravitySettingsList } from "../../../compenents/Setting/Payment/GravitySettingsList";
import {
  useGetCustomerCategoriesMutation,
  useGetDealerPaymentMethodsMutation,
  useGetMiscInventoryDataMutation,
  useUpdateSetupProfileMutation,
} from "../../../redux/reducer/features/Integration/DmsSetupSlice";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../redux/reducer/rootReducer";
import {
  CustomerCategory,
  DmsPaymentMethod,
  MiscInventoryData,
  SetupProfile,
} from "../../../models/features/SetupProfile/SetupProfile";
import InfoIcon from "@mui/icons-material/Info";
import {
  setDMSCustomerCategoryId,
  setDMSPaymentMethodId,
  setDMSSetupDefault,
} from "../../../redux/reducer/features/Auth/authSlice";
import { PartsPortalType } from "../../../models/features/ShopifySetting/ShoppingPortal/ShoppingPortal";
import { DmsSetupDefaultType } from "../../../models/features/Integration/DmsSetup";

export const GravitySetting: React.FunctionComponent = () => {
  const dispatch = useDispatch();
  const partsPortalSetting = useSelector(
    (state: AppState) => state.shoppingPortalReducer
  );
  const locations = useSelector(
    (state: AppState) => state.authReducer.dmsSetup?.dmsLocations
  );
  const { setupId, dmsSetup } = useSelector(
    (state: AppState) => state.authReducer
  );
  const [dmsType, setDmsType] = React.useState<number | undefined>(undefined);
  const dmsPaymentMethodId = useSelector(
    (state: AppState) => state.authReducer.dmsSetup?.dmsPaymentMethodId
  );
  const dmsCustomerCategoryId = useSelector(
    (state: AppState) => state.authReducer.dmsSetup?.customerCategoryId
  );
  const defaultShippingMiscId = useSelector(
    (state: AppState) => state.authReducer.dmsSetup?.defaultShippingMiscId
  );
  const defaultShippingMfrId = useSelector(
    (state: AppState) => state.authReducer.dmsSetup?.defaultShippingMfrId
  );
  const [openAdd, setOpenAdd] = React.useState(false);
  const [openAddPayPal, setOpenAddPayPal] = React.useState(false);
  const [showPaymentSettings, setShowPaymentSettings] = useState(false);
  const {
    data,
    isLoading,
    refetch: refetchGravitySettings,
  } = useGetGravitySettingsQuery();
  const {
    data: paypalSettingData,
    isLoading: payPalLoading,
    refetch: refetchPaypalSettings,
  } = useGetPayPalSettingsQuery();
  const [paymentMethodsMutation, paymentMethodsMutationResult] =
    useGetDealerPaymentMethodsMutation();
  const [customerCategoryMutation, customerCategoryMutationResult] =
    useGetCustomerCategoriesMutation();
  const [updateDmsSetupMutation, updateDmsSetupMutationResult] =
    useUpdateSetupProfileMutation();
  const [addGravitySettingMutation, addGravitySettingMutationResult] =
    useAddGravitySettingMutation();

  const [addPayPalSettingMutation, addPayPalSettingMutationResult] =
    useAddPayPalSettingMutation();
  const [deleteSettingMutation, deleteSettingMutationResult] =
    useDeleteGravityGatewaySettingMutation();
  const [deletePayPalSettingMutation, deletePayPalSettingMutationResult] =
    useDeletePayPalSettingMutation();
  const [miscInventoryDataMutation, miscInventoryDataMutationResult] =
    useGetMiscInventoryDataMutation();
  const [gravitySettings, setGravitySettings] = React.useState<
    GravitySettingModel[]
  >([]);
  const [payPalSettings, setPayPalSettings] = React.useState<PayPalSetting[]>(
    []
  );
  const [paymentMethods, setPaymentMethods] = useState<DmsPaymentMethod[]>([]);
  const [customerCategories, setCustomerCategories] = useState<
    CustomerCategory[]
  >([]);
  const [miscInventoryData, setMiscInventoryData] = useState<
    MiscInventoryData[]
  >([]);
  const [searchMiscInventory, setSearchMiscInventory] = useState("");
  const defaultShippingItem: MiscInventoryData = {
    inventoryMiscellaneousId: defaultShippingMiscId ?? "",
    manufacturerId: defaultShippingMfrId ?? "",
  };
  const [shippingItem, setShippingItem] =
    React.useState<MiscInventoryData | null>(defaultShippingItem);
  const [open, setOpen] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [paymentMethodId, setPaymentMethodId] =
    React.useState(dmsPaymentMethodId);
  const [customerCategoryId, setCustomerCategoryId] = React.useState(
    dmsCustomerCategoryId
  );
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openAddMenu = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const fetchMiscInventoryData = async () => {
    var data = {
      dealerId:
        locations !== undefined && locations.length > 0
          ? locations[0]?.dealerId.toString()
          : "",
      search: searchMiscInventory,
      PageNumber: 1,
      PageSize: 20,
    };
    await miscInventoryDataMutation(data)
      .then((response: any) => {
        if (response.data && response?.data?.entityList.length > 0) {
          setMiscInventoryData(response.data.entityList);
        }
      })
      .catch((error) => {})
      .finally(() => {});
  };

  React.useEffect(() => {
    fetchMiscInventoryData();
  }, []);

  React.useEffect(() => {
    if (searchMiscInventory) {
      const timer = setTimeout(() => {
        fetchMiscInventoryData();
      }, 1500);
      return () => clearInterval(timer);
    }
  }, [searchMiscInventory]);

  React.useEffect(() => {
    paymentMethodsMutation({
      dealerId:
        locations !== undefined && locations.length > 0
          ? locations[0]?.dealerId.toString()
          : "",
    }).then((res: any) => {
      if (res && res.data && res.data.status === 200) {
        setPaymentMethods(res.data.entityList);
      }
    });
    customerCategoryMutation({
      dealerId:
        locations !== undefined && locations.length > 0
          ? locations[0]?.dealerId.toString()
          : "",
    }).then((res: any) => {
      if (res && res.data && res.data.status === 200) {
        setCustomerCategories(res.data.entityList);
      }
    });
  }, []);

  React.useEffect(() => {
    if (data) {
      setGravitySettings(data.entityList);
    }
  }, [data]);
  React.useEffect(() => {
    if (paypalSettingData) {
      setPayPalSettings(paypalSettingData.entityList);
    }
  }, [paypalSettingData]);
  React.useEffect(() => {
    if (dmsSetup && dmsSetup.dmsLocations.length > 0) {
      setDmsType(dmsSetup.dmsLocations[0].dmsType);
    }
  }, [dmsSetup]);
  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };
  const handleSavePaymentCategorization = () => {
    let values: SetupProfile = {
      IsUpdateCustomerAndPaymentOnly: true,
      id: setupId ?? "",
      customerCategoryId: customerCategoryId,
      dmsPaymentMethodId: paymentMethodId,
      syncExisting: false,
      isDefaultShippingOnly: true,
      setupDefaultType: DmsSetupDefaultType.ShippingItem,
      setupDefaultValue1: shippingItem?.inventoryMiscellaneousId ?? "",
      setupDefaultValue2: shippingItem?.manufacturerId ?? "",
    };
    updateDmsSetupMutation({ data: values }).then((res: any) => {
      if (res && res.data) {
        if (res.data.status === 200) {
          dispatch(
            setDMSCustomerCategoryId({ value: values.customerCategoryId ?? "" })
          );
          dispatch(
            setDMSPaymentMethodId({ value: values.dmsPaymentMethodId ?? "" })
          );
          dispatch(
            setDMSSetupDefault({
              type: values.setupDefaultType ?? "",
              value1: values.setupDefaultValue1 ?? "",
              value2: values.setupDefaultValue2 ?? "",
            })
          );
        }
      }
    });
  };
  const handleGravitySettingSubmit = (values: GravitySettingModel) => {
    setErrorMessage("");
    values.id = undefined;
    addGravitySettingMutation({
      data: {
        ...values,
      },
    }).then((res: any) => {
      if (res && res.data) {
        if (res.data.status === 200) {
          setOpenAdd(false);
          refetchPaypalSettings();
        } else {
          setErrorMessage(res.data.message);
        }
      }
    });
  };
  const handlePayPalSettingSubmit = (values: PayPalSetting) => {
    setErrorMessage("");
    values.id = undefined;
    addPayPalSettingMutation({
      data: {
        ...values,
      },
    }).then((res: any) => {
      if (res && res.data) {
        if (res.data.status === 200) {
          setOpenAddPayPal(false);
          refetchPaypalSettings();
        } else {
          setErrorMessage(res.data.message);
        }
      }
    });
  };

  const handleGravitySettingDelete = (settingId: string) => {
    deleteSettingMutation({
      data: {
        id: settingId,
      },
    }).then((res: any) => {
      if (res && res.data) {
        refetchGravitySettings();
      }
    });
  };

  const handlePayPalSettingDelete = (settingId: string) => {
    deletePayPalSettingMutation({
      data: {
        id: settingId,
      },
    }).then((res: any) => {
      if (res && res.data) {
        refetchPaypalSettings();
      }
    });
  };
  const handleRefetchPaypal = () => {
    refetchPaypalSettings();
  };
  const handleRefetchGravity = () => {
    refetchGravitySettings();
  };
  useEffect(() => {
    if (
      partsPortalSetting &&
      partsPortalSetting?.isPortalEnabled === true &&
      partsPortalSetting.portalType === PartsPortalType.StandAlone
    ) {
      setShowPaymentSettings(true);
    } else {
      setShowPaymentSettings(false);
    }
  }, [partsPortalSetting]);
  return (
    <>
      <PageLoader isLoading={isLoading || payPalLoading}></PageLoader>
      <Container maxWidth={false}>
        <Box sx={{ flexGrow: 1, pb: 2 }}>
          <Grid container spacing={8}>
            <Grid item xs={4}>
              <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
                Order / Payment Settings
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <Box>
          <Card>
            <Typography
              sx={{ margin: 2, fontWeight: "bold", fontSize: "1rem" }}
              gutterBottom
            >
              Order Categorization
            </Typography>
            <CardContent>
              <Typography mb={2}>
                How do you want to categorize new customer sales in your DMS?{" "}
              </Typography>
              <Grid
                container
                spacing={5}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-end",
                }}
              >
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel id="method" sx={{ left: "-13px" }}>
                      Payment Method
                    </InputLabel>
                    <Select
                      labelId="method"
                      id="paymentMethod"
                      size="small"
                      variant="standard"
                      fullWidth
                      defaultValue={dmsPaymentMethodId}
                      value={paymentMethodId}
                      onChange={(e) => setPaymentMethodId(e.target.value)}
                    >
                      {paymentMethods.map((col) => (
                        <MenuItem
                          key={col.paymentTypeID}
                          value={col.paymentTypeID}
                        >
                          <ListItemText primary={col.description} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <Tooltip
                      title={
                        "This category will be used when creating a new customer in DMS, always select the Individual Customer category. You can create a new category for this purpose  (in DMS) or select an existing one from the dropdown."
                      }
                    >
                      <InputLabel id="method" sx={{ left: "-13px" }}>
                        Customer Category
                        {
                          <IconButton size="small">
                            <InfoIcon />
                          </IconButton>
                        }
                      </InputLabel>
                    </Tooltip>
                    <Select
                      labelId="customCategory"
                      id="customerCategory"
                      size="small"
                      variant="standard"
                      fullWidth
                      defaultValue={dmsCustomerCategoryId}
                      value={customerCategoryId}
                      onChange={(e) => setCustomerCategoryId(e.target.value)}
                    >
                      {customerCategories.map((col) => (
                        <MenuItem
                          key={col.customerCategoryId}
                          value={col.customerCategoryId}
                        >
                          <ListItemText primary={col.name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                {dmsType === 0 && (
                  <Grid item xs={6}>
                    <Autocomplete
                      options={miscInventoryData}
                      getOptionLabel={(option) =>
                        option.inventoryMiscellaneousId && option.manufacturerId
                          ? `${option.inventoryMiscellaneousId} - ${option.manufacturerId}`
                          : option.inventoryMiscellaneousId ||
                            option.manufacturerId ||
                            ""
                      }
                      defaultValue={defaultShippingItem}
                      value={shippingItem}
                      loading={miscInventoryDataMutationResult.isLoading}
                      onInputChange={(event, newInputValue) => {
                        setSearchMiscInventory(newInputValue);
                      }}
                      onChange={(e, newValue) => {
                        setShippingItem(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Shipping Inventory"
                          variant="standard"
                          size="small"
                        />
                      )}
                    />
                  </Grid>
                )}
              </Grid>
              <Box mt={3}>
                <Button
                  variant="contained"
                  onClick={handleSavePaymentCategorization}
                  endIcon={
                    updateDmsSetupMutationResult.isLoading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : (
                      <></>
                    )
                  }
                  disabled={
                    updateDmsSetupMutationResult.isLoading ||
                    (dmsType !== 0 && !customerCategoryId && !paymentMethodId)
                  }
                >
                  Save
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Box>
        {showPaymentSettings && (
          <Box mt={3}>
            <Card>
              <Box
                m={2}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography
                  sx={{ fontWeight: "bold", fontSize: "1rem" }}
                  gutterBottom
                >
                  Parts Payment Processing
                </Typography>
                <Button
                  id="basic-button"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  color="primary"
                  variant="contained"
                  size="small"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                  endIcon={<KeyboardArrowDownIcon />}
                  startIcon={<AddIcon />}
                >
                  Add Setting
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={openAddMenu}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      setOpenAdd(true);
                    }}
                  >
                    Gravity
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setOpenAddPayPal(true);
                    }}
                  >
                    PayPal
                  </MenuItem>
                </Menu>{" "}
              </Box>
              <CardContent>
                {gravitySettings ? (
                  <GravitySettingsList
                    handleSettingDelete={handleGravitySettingDelete}
                    paymentSettings={gravitySettings}
                    handleRefetchSetting={handleRefetchGravity}
                  />
                ) : (
                  ""
                )}
                <br />
                {payPalSettings ? (
                  <PayPalSettingsList
                    handleSettingDelete={handlePayPalSettingDelete}
                    paymentSettings={payPalSettings}
                    handleRefetchSetting={handleRefetchPaypal}
                  />
                ) : (
                  ""
                )}
              </CardContent>
            </Card>
          </Box>
        )}
      </Container>
      <AddGravitySettingDialog
        isEdit={false}
        isOpen={openAdd}
        errorMessage={errorMessage}
        isLoading={addGravitySettingMutationResult.isLoading}
        handleSettingSubmit={handleGravitySettingSubmit}
        onClose={() => {
          setOpenAdd(false);
          setErrorMessage("");
        }}
      ></AddGravitySettingDialog>
      <AddPayPalSettingDialog
        isEdit={false}
        errorMessage={errorMessage}
        isLoading={addPayPalSettingMutationResult.isLoading}
        isOpen={openAddPayPal}
        handleSettingSubmit={handlePayPalSettingSubmit}
        onClose={() => {
          setOpenAddPayPal(false);
          setErrorMessage("");
        }}
      ></AddPayPalSettingDialog>
    </>
  );
};
